import React, { Component } from 'react';
import { Modal, Tabs, Spin, message } from 'antd';
import { AddFromBlind, AddCustom } from './UpdateView';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import deepClone from '../../../shared/deepClone';
import genConfig from '../../../shared/genConfig';

const { TabPane } = Tabs;
const typeInConfig = {
    add: {
        title: '添加研究中心',
        message: '新建成功',
        url: API_URL.site.addSite,
    },
    edit: {
        title: '修改研究中心',
        message: '修改成功',
        url: API_URL.site.modifySite,
    },
};

class Update extends Component {
    state = {
        data: {},
        loading: false,
        visible: false,
        activeKey: undefined,
        stageList: [],
    }

    config = {}

    record = {}

    isBoundBlind = false   // 非盲项目是否关联盲态项目
    isBeforeStartInv = false   // 项目是否设置启动前项目

    panes = [{
        title: '从盲态项目添加',
        key: 'fromBlind',
        Content: AddFromBlind,
    }, {
        title: '自定义添加',
        key: 'custom',
        Content: AddCustom,
    }]

    beforeStartPanes = [{
        title: '从启动前项目添加',
        key: 'fromBeforStart',
        Content: AddFromBlind,
    }, {
        title: '自定义添加',
        key: 'custom',
        Content: AddCustom,
    }]

    show = (record, type) => {
        const { blindInvId } = sessionStorage;
        const { beforeStartInvDatas } = this.props;
        const beforeStartInvId = beforeStartInvDatas ? beforeStartInvDatas.beforeStartInvId : undefined;
        this.config = genConfig(typeInConfig, type);
        this.record = record;
        this.isBoundBlind = !!blindInvId;
        this.isBeforeStartInv = !!beforeStartInvId;
        const data = {};
        if (this.config.edit) {
            const { hospitalId, hospitalName, cityName, hospitalDepartmentId, hospitalDepartmentName, investigationSiteCode, contractVos, groupLeaderUnit, groupManagerBeforeStart ,relatedSiteSurvey ,sponsorSelected, courtyardArea, hospitalMainId, unblindingRisk, unblindingRiskLevelShow, stageIds } = this.record;
            data.hospitalMainId = hospitalMainId;
            data.hospitalId = hospitalId;
            data.hospitalMainName = hospitalName;
            data.cityName = cityName;
            data.departmentId = hospitalDepartmentId;
            data.departmentName = hospitalDepartmentName;
            data.siteName = hospitalName;
            data.siteCode = investigationSiteCode;
            data.contractVos = contractVos ? deepClone(contractVos) : [];
            data.groupLeaderUnit = groupLeaderUnit;
            data.groupManagerBeforeStart = groupManagerBeforeStart;
            data.relatedSiteSurvey = relatedSiteSurvey;
            data.sponsorSelected = sponsorSelected;
            data.courtyardArea = courtyardArea;
            data.unblindingRisk = unblindingRisk;
            data.unblindingRiskLevelShow = unblindingRiskLevelShow;
            data.stageIds = stageIds ? stageIds.split(',') : undefined;
        }

        const params = {};
        if (this.config.add && this.isBoundBlind) {
            params.activeKey = 'fromBlind';
        } else if (this.config.add && this.isBeforeStartInv) {
            params.activeKey = 'fromBeforStart';
        }
        if (this.config.add) {
            this.queryInvestigationStage();
        }

        this.setState({
            data,
            ...params,
            visible: true,
        });
        this.loadTypeConfigureList();
    }

    loadTypeConfigureList = () => {
        const options = {
            method: 'POST',
            url: API_URL.common.typeConfigureList,
            data: {},
            dataType: 'json',
            doneResult: res => {
                this.setState({ 
                    stageList: res.stageList,
                });
            }
        }
        $.sendRequest(options)
    }

    //获取该项目的项目阶段
    queryInvestigationStage = () => {
        const { invId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId: invId },
            dataType: 'json',
            doneResult: res => {
                const { data } = this.state;
                data.stageIds = (res.data || []).map(el => `${el.typeConfigureId}`);
                this.setState({ data });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    hide = () => {
        this.setState({
            data: {},
            visible: false,
            activeKey: undefined,
        });
    }

    handleChange = data => {
        this.setState({ data });
    }

    handleTabsChange = activeKey => {
        this.setState({
            data: {},
            activeKey,
        },() => {
            if (activeKey === 'custom') {
                this.queryInvestigationStage();
            }
        });
    }

    confirm = () => {
        const { data, activeKey } = this.state;
        const { investigationSiteId } = this.record;
        const { siteId, hospitalMainId, departmentId, siteName, siteCode, contractVos, groupLeaderUnit,groupManagerBeforeStart ,relatedSiteSurvey ,sponsorSelected, hospitalId, needCourtyardArea, unblindingRisk, unblindingRiskLevelShow, stageIds } = data;
        if (activeKey === 'fromBlind' || activeKey === 'fromBeforStart') {
            if (!siteId) {
                return message.warning('中心不能为空！');
            }
        } else {
            if (!hospitalMainId) {
                return message.warning('所属医院不能为空！');
            }
            if (needCourtyardArea && !hospitalId) {
                return message.warning('所属院区不能为空！');
            }
            if (!departmentId) {
                return message.warning('所属科室不能为空！');
            }
            if (!siteCode) {
                return message.warning('中心编号不能为空！');
            }
            if (!(stageIds || []).length) {
                return message.warning('研究中心项目阶段不能为空！');
            }
        }
        if (!(contractVos || []).length) {
            return message.warning('关联JDE号不能为空！');
        }

        const params = {};
        contractVos.forEach((item, index) => {
            const { contractType, relatedType, investigationJdeContractId } = item;
            params[`contractSites[${index}].investigationJdeContractId`] = investigationJdeContractId;
            params[`contractSites[${index}].contractType`] = contractType;
            params[`contractSites[${index}].relatedType`] = relatedType;
        });

        let url = this.config.url;
        (activeKey === 'fromBlind' || activeKey === 'fromBeforStart') && (url = API_URL.site.addInvestigationSiteUnblind);

        if (unblindingRisk) {
            const _this = this;
            Modal.info({
                title: `医院科室存在破盲风险，破盲风险等级${unblindingRiskLevelShow}`,
                content: '',
                onOk() {
                    _this.setState({ loading: true });
                    $.sendRequest({
                        url,
                        data: {
                            ...params,
                            siteId,
                            hospitalId,
                            departmentId,
                            siteName,
                            siteCode,
                            investigationSiteId,
                            createType: activeKey === 'fromBlind' ? 'UnBlind' : 'BeforeStart',
                            groupLeaderUnit: groupLeaderUnit || 0,
                            groupManagerBeforeStart: groupManagerBeforeStart || 0,
                            relatedSiteSurvey: relatedSiteSurvey || 0,
                            sponsorSelected,
                            stageIds: (stageIds || []).join(','),
                        },
                        dataType: 'json',
                        doneResult: () => {
                            message.success(_this.config.message);
                            _this.hide();
                            _this.setState({ loading: false }, () => {
                                _this.props.loadData();
                            });
                        },
                        errorResult: () => {
                            _this.setState({ loading: false });
                        },
                    });
                },
                okText:'确定',
            });
            return
        }
        this.setState({ loading: true });
        $.sendRequest({
            url,
            data: {
                ...params,
                siteId,
                hospitalId,
                departmentId,
                siteName,
                siteCode,
                investigationSiteId,
                createType: activeKey === 'fromBlind' ? 'UnBlind' : 'BeforeStart',
                groupLeaderUnit: groupLeaderUnit || 0,
                groupManagerBeforeStart: groupManagerBeforeStart || 0,
                relatedSiteSurvey: relatedSiteSurvey || 0,
                sponsorSelected,
                stageIds: (stageIds || []).join(','),
            },
            dataType: 'json',
            doneResult: () => {
                message.success(this.config.message);
                this.hide();
                this.setState({ loading: false }, () => {
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        });
    }

    getContent = ({ key, Content }) => {
        const { data, activeKey } = this.state;
        const { beforeStartInvDatas } = this.props;
        const beforeStartInvId = beforeStartInvDatas ? beforeStartInvDatas.beforeStartInvId : undefined;
        if (activeKey === key) {
            return (
                <Content config={this.config} data={data} onChange={this.handleChange} beforeStartInvId={beforeStartInvId} />
            );
        }
        return null;
    }

    render() {
        const { visible, loading, data, activeKey, stageList } = this.state;
        console.log(stageList);
        return (
            <Modal
                title={this.config.title}
                visible={visible}
                onCancel={this.hide}
                onOk={this.confirm}
                confirmLoading={loading}
                maskClosable={false}
                width="520px"
            >
                <Spin spinning={loading}>
                    <div className="modal-content form-list fortyPercentage" style={{ padding: 0 }}>
                        {
                            (this.config.add && this.isBoundBlind) ?
                                <Tabs activeKey={activeKey} onChange={this.handleTabsChange}>
                                    {this.panes.map(pane => <TabPane tab={pane.title} key={pane.key}>{this.getContent(pane)}</TabPane>)}
                                </Tabs>
                            : (this.config.add && this.isBeforeStartInv) ?
                                <Tabs activeKey={activeKey} onChange={this.handleTabsChange}>
                                    {this.beforeStartPanes.map(pane => <TabPane tab={pane.title} key={pane.key}>{this.getContent(pane)}</TabPane>)}
                                </Tabs> :
                                <AddCustom 
                                    config={this.config} 
                                    data={data} 
                                    stageList={stageList}
                                    onChange={this.handleChange} 
                                    ref={el => this.AddCustom = el}
                                />
                        }
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default Update;



// WEBPACK FOOTER //
// ./src/components/site/researchCenterDetail/components/Update.js